import { Product, PRODUCTS } from '@boltenergy-be/shared'

export const MINIMUM_INSTALMENT: number = 20

export const BRUSSELS_AIRPORT_PRODUCER_SLUG = 'christel-rutger'

export const DEFAULT_PRODUCTS: Product[] = [PRODUCTS.variableOnline, PRODUCTS.variableOffline]

export const INTERNAL_REGISTRATION_URL_PARAMS = {
  IS_CLOSED_WON: 'isClosedWon',
  IS_INVALID_CREDIT_CHECK_FLOW: 'isInvalidCreditCheckFlow',
  IS_INVALID_NO_EAN_FLOW: 'isInvalidNoEanFlow',
  IS_NOT_TO_BE_CONFIRMED: 'isNotToBeConfirmed'
} as const
